import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUrls } from '../../../../config/api-urls/api-urls';
import { MainService } from '../../../../provider/main.service';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-query-mgt',
  templateUrl: './query-mgt.component.html',
  styleUrls: ['./query-mgt.component.css']
})
export class QueryMgtComponent implements OnInit {

  queryListData: any = [];
  itemPerPage = 10;
  currentPage = 1;
  total: any;
  queryId: any;

  constructor(public service: MainService, private router: Router) { }

  ngOnInit() {
    this.queryList();
  }

  // program list api inntegration 
  queryList() {
    this.service.showSpinner();
    this.service.getApi(ApiUrls.query_List + `?pageNumber=${this.currentPage}&limit=${this.itemPerPage}`, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.queryListData = res.result ? res.result : [];
        this.total = res.paginationData.total;
        this.currentPage = res.paginationData.page;

      }
      else {
        this.queryListData = res.result ? res.result : [];
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  pagination(event: any) {
    this.queryListData = [];
    this.currentPage = event;
    this.queryList()
  }

  // deleteQuery api integration 

  deleteQuery() {
    const data = {
      _id: this.queryId,
      status: "DELETE"
    }
    this.service.showSpinner();
    this.service.postApi(ApiUrls.actionPerform_query, data, 1).subscribe((res) => {
      this.service.hideSpinner();
      if (res.responseCode == 200) {
        this.service.successToast('Query deleted successfully')
        this.queryListData = res.result;
        $('#deleteUser').modal('hide')
        this.queryList();
      }
      else {
        this.service.errorToast(res.responseMessage)
      }
    }, err => {
      this.service.hideSpinner();
      this.service.errorToast(err.responseMessage)
    })
  }

  deleteUserModal(id: any) {
    this.queryId = id;
    $('#deleteUser').modal('show')
  }

}
